import React from 'react';
import { AccordionContainer } from '../../../../../../common/components/accordion/containers/accordion.containers';
import { InputContainer } from '../../../../../../common/components/form/input/containers/input.container';

export default function AdminLevelCityBasicInfoComponent({
    handleInnerFormChange,GlobaladminLevelFourData,
    selectedCategory, parentAdmin,globalAdmin,globalAdmin3
}: any) {
    return (
        <>
            <AccordionContainer
                headerTitle="New Admin Level 2"
                expandedPanel="userInfo"
                child={
                    <div className="grid md:grid-cols-2 gap-4">
  <InputContainer
                            label="Global Admin Layer 4"
                            labelField="Name"
                            list={GlobaladminLevelFourData}
                            type="select"
                            isDisabled={!!selectedCategory?.GlobalCityId}
                            optionName="Select Global Cities"
                            value={selectedCategory?.GlobalAdminLayer4Id}
                            valueField="GlobalAdminLayer4Id"
                            onValueChange={(event: any) => {
                                const selectedId = Number(event.target.value);

                                handleInnerFormChange(
                                    selectedId,
                                    "GlobalAdminLayer4Id"
                                );
                            }}
                        />
                        <InputContainer
                            label="Global Admin Layer 3"
                            labelField="Name"
                            list={globalAdmin3}
                            type="select"
                            isDisabled={!!selectedCategory?.GlobalCityId}
                            optionName="Select Global Admin Layer 3"
                            value={selectedCategory?.GlobalAdminLayer3Id}
                            valueField="GlobalAdminLayer3Id"
                            onValueChange={(event: any) => {
                                const selectedId = Number(event.target.value);

                                handleInnerFormChange(
                                    selectedId,
                                    "GlobalAdminLayer3Id"
                                );
                            }}
                        />
                         <InputContainer
                            label="Global Admin Layer 2"
                            labelField="Name"
                            list={parentAdmin}
                            type="select"
                            isDisabled={!!selectedCategory?.GlobalCityId}
                            optionName="Select Global Admin Layer 1"
                            value={selectedCategory?.GlobalAdminLayer2Id}
                            valueField="GlobalAdminLayer2Id"
                            onValueChange={(event: any) => {
                                const selectedId = Number(event.target.value);

                                handleInnerFormChange(
                                    selectedId,
                                    "GlobalAdminLayer2Id"
                                );
                            }}
                        />
                        <InputContainer
                            label="Global Admin Layer 1"
                            labelField="Name"
                            list={globalAdmin}
                            type="select"
                            isDisabled={!!selectedCategory?.GlobalCityId}
                            optionName="Select Global Admin Layer 1"
                            value={selectedCategory?.GlobalAdminLayer1Id}
                            valueField="GlobalAdminLayer1Id"
                            onValueChange={(event: any) => {
                                const selectedId = Number(event.target.value);

                                handleInnerFormChange(
                                    selectedId,
                                    "GlobalAdminLayer1Id"
                                );
                            }}
                        />
                        <InputContainer
                            label="Std Code"
                            name="Code"
                            type="text"
                            value={selectedCategory?.Code}
                            isDisabled={!!selectedCategory?.GlobalCityId}
                            onValueChange={(event: any) => {
                                handleInnerFormChange(
                                    event.target.value,
                                    'Code'
                                );
                            }}
                        />

                        <InputContainer
                            label="Group Name"
                            name="Name"
                            type="text"
                            value={selectedCategory?.Name}
                            isDisabled={!!selectedCategory?.GlobalCityId}
                            onValueChange={(event: any) => {
                                handleInnerFormChange(
                                    event.target.value,
                                    'Name'
                                );
                            }}
                        />
                        <div className="md:col-span-2">
                            <InputContainer
                                label="Description"
                                name="Description"
                                type="text"
                                value={selectedCategory?.Description}
                                onValueChange={(event: any) => {
                                    handleInnerFormChange(
                                        event.target.value,
                                        'Description'
                                    );
                                }}
                            />
                        </div>


                    </div>
                }
            />
        </>
    );
}